import { Box } from "@mui/material";

import { UseGetFlag } from "../../../app/launchDarkly";
import { setCreateSubstepOpen, setInitialSubstep, setRecipeData, setSubstepToEdit } from "../../../app/recipeCreation/createRecipe.slice";
import { recipeSubStepInterface2, Substep, timerInstructionInterface } from "../../../app/recipeCreation/createRecipe.types";
import { setRecipe } from "../../../app/recipePage/recipePage.slice";
import { useAppDispatch, useAppSelector } from "../../../app/store/hooks";
import { BlueDot, DeleteStepIcon } from "../../../utils/iconRefs/recipeStepsIcons";
import { recipeE3TransformerQL2FS } from "../../../utils/RecipeBackEnd/hasuraFSMigrationTransformers";
import { LocationEnum } from "../utils/constants";
import LocationUI from "./locationUI";
import SettingsDisplay from "./settingsDisplay";

const TimerInstruction = ({ stepId, stepIndex, substep, userCreatedRecipe, substepIndex }: { stepId: string | null, stepIndex: number, substep: timerInstructionInterface, userCreatedRecipe: boolean, substepIndex: number }) => {
    const editStepView = useAppSelector((state) => state.recipeCreation.editStepView)
    const recipeData = useAppSelector((state) => state.recipeCreation.recipeData)
    const { name, parameters, type, id, subStepUId } = substep
    const { settings } = parameters
    const step_id = recipeData.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.id
    const dispatch = useAppDispatch()
    const substepDataV2: Substep = { ...substep, Recipe_Presets: substep?.Recipe_Presets ?? [], SubSteps_Ingredients_E3s: substep?.SubSteps_Ingredients_E3s ?? [] };

    const onEdit = () => {
        dispatch(setSubstepToEdit({ SubstepsE3: substep, subStep_id: substep.id, subStepUId, subStep_rank: 0, step_id }))
        dispatch(setCreateSubstepOpen(true))
    }

    const onDelete = () => {
        if (editStepView) {
            const recipeDataEditable = JSON.parse(JSON.stringify(recipeData))
            const foundSubStep = recipeData.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.Steps_Substeps.find((Steps_Substeps: recipeSubStepInterface2) => Steps_Substeps.SubstepsE3 === substep);
            const subStepIndex = recipeData.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.Steps_Substeps.indexOf(foundSubStep)
            if (subStepIndex > -1) {
                recipeDataEditable.Recipe_Variations[0].RecipeVariations_Steps[0].StepsE3.Steps_Substeps.splice(subStepIndex, 1);
                dispatch(setRecipeData(recipeDataEditable))
                dispatch(setRecipe({ recipe: recipeE3TransformerQL2FS(recipeDataEditable) }))
            }
        }
    }
    return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: { xs: 'space-between', md: 'space-around' } }}>
            <Box onClick={onDelete} sx={{ padding: editStepView ? '10px 10px 10px 4px' : '10px 10px 10px 8px' }}>
                {editStepView ? <DeleteStepIcon /> : <BlueDot />}
            </Box>
            <Box sx={{ width: '90%', boxShadow: '0px 1px 4px 0px #00000040', borderRadius: '10px', overflow: 'hidden' }}>
                <LocationUI
                    location={LocationEnum.JAR}
                    name={name}
                    onEdit={onEdit}
                    stepId={stepId}
                    stepIndex={stepIndex}
                    substep={substepDataV2}
                    substepId={id}
                    substepIndex={substepIndex}
                    subStepUId={subStepUId}
                    type={type}
                    userCreatedRecipe={userCreatedRecipe} />
                <Box>
                    <SettingsDisplay settings={settings} />
                </Box>
            </Box>
        </Box>
    )
}

export default TimerInstruction